<template>
  <div :class="isOverlay ? 'dishes-game-wrap overlayed' : 'dishes-game-wrap'">
    <div class="intro-game-dishes">
      <div class="intro--page section--slide">
        <img class="logo-section" src="../assets/menu-item-off.svg" />
        <h2 class="title-section">
          {{
            $i18n.locale == 'it' ?
            "BUON CIBO, BUON MOOD"
            :
            "GOOD FOOD, GOOD MOOD"
          }}
        </h2>
        <p class="subtitle-section">
          {{
            $i18n.locale == 'it' ?
            "Accomodati al ristorante sostenibile e scopri quanto costa davvero il tuo cibo!"
            :
            "Take a seat at the sustainable restaurant and learn how much your food really costs!"
          }}
        </p>
      </div>
      <div class="intro--earth section--slide">
        <div class="intro-chat-wrap">
          <div class="intro-chat-earth">
            <div class="balloon-intro">
              <p>
                {{
                  $i18n.locale == 'it' ?
                  "Benvenuto/a al Ristorante Sano e Sostenibile."
                  :
                  "Welcome to the Healthy and Sustainable Restaurant!" 
                }}
                <br/>
                {{
                  $i18n.locale == 'it' ?
                  "Scegli cosa vorresti mangiare oggi, ma fa’ attenzione: ogni piatto ha un costo per l’ambiente!"
                  :
                  "Choose four dishes you'd like to add to your tray today, but be careful: each one comes at a cost for your health and the one of the environment."
                }}
                <br/><br/>
                <span v-html="
                  $i18n.locale == 'it' ?
                  `Quanta CO<sub>2</sub> è stata rilasciata nell’atmosfera per produrre ciò che metterai nel piatto oggi?<br/>
                  Stai scegliendo cibo che ti fa bene?`
                  :
                  `That's right, we're both paying for your meal, so try to see if you can choose the foods that are good for your health and that release the least amount of CO<sub>2</sub> when they're produced!`
                "></span>
                <br/><br/>
                {{
                  $i18n.locale == 'it' ?
                  `Alla fine riceverai lo scontrino: cerca di scegliere qualcosa che non sia “troppo caro”!`
                  :
                  "Don't worry, we'll have a look at your bill, in the end, to see what is the cost of your choices."
                }}
              </p>
            </div>
            <div class="button-intro" @click="showSlider">
              <p>
                {{
                  $i18n.locale == 'it' ?
                  "Giochiamo!"
                  :
                  "Let's play!"
                }}
              </p>
            </div>
          </div>
          <img class="avatar-intro-earth" src="../assets/pdcm.png" />
        </div>
      </div>
    </div>
    <DishesSlider 
      
      :isOverlay="isOverlay"
    />
    <BadgesWrap  v-if="!isOverlay" :start="openBadgeType" :type="openBadgeType" :isOverlay="isOverlay" />
  </div>
</template>

<script>
import DishesSlider from '@/components/DishesSlider.vue'
import BadgesWrap from '@/components/BadgesWrap.vue'
import {mapState} from 'vuex';
import {gsap, TimelineMax, Power2} from 'gsap'

export default {
  name: 'DishesWrap',
  props: ['startDishesOverlay', 'isOverlay'],
  components: {
    DishesSlider,
    BadgesWrap
  },
  methods: {
    transitionIn(){
      this.$store.dispatch('setMenuCtaVisibility',!this.isOverlay);
      
      let TL = new TimelineMax();

      TL
      .to('.logo-section',{duration: .75, scale: 1, opacity:1, ease: Power2.easeOut})
      .to('.title-section',{duration: .75, y: 0, opacity:1, ease: Power2.easeOut},'-=.25')
      .to('.subtitle-section',{duration: .75, y: 0, opacity:1, ease: Power2.easeOut},'-=.25')
      .to('.intro-game-dishes',{duration: .75, x: '-100vw', ease: Power2.easeOut},'+=2.5')
      .to('.avatar-intro-earth',{duration: .5, opacity:1, x: 0, ease: Power2.easeInOut},'-=.25')
      .to('.balloon-intro',{duration: .5, opacity:1, ease: Power2.easeInOut},'-=.25')
      .to('.button-intro',{duration: .5, opacity:1, ease: Power2.easeInOut},'-=.25')
    },
    showSlider(){
      gsap.to('.intro-game-dishes',{duration: .75, x: '-200vw', ease: Power2.easeOut})
      gsap.to('.dishes-slider--wrap',
        {
          duration: .75, 
          left: 0, 
          ease: Power2.easeOut,
          onComplete: () => {
            if(this.isOverlay){
              gsap.to('.dishes-game-wrap .close--overlay', {opacity: 1})
            }
          }
        })
    }
  },
  mounted(){
    
    if(!this.isOverlay) {
      gsap.to('.dishes-game-wrap', {duration: .75, left: 0, ease: Power2.easeInOut})
      this.$store.dispatch('setMenuCtaVisibility',true);
      setTimeout(this.transitionIn, 1000)
    }
  },
  watch:{
    startDishesOverlay(val){
      
      if(val === true){
        gsap.to('.dishes-game-wrap', {duration: .75, left: 0, ease: Power2.easeInOut})
        setTimeout(this.transitionIn, 1000)
      }
    }
  },
  computed:{
    ...mapState({
      openBadgeType: state => state.openBadgeType
    })
  }
}
</script>

<style lang="scss">
  .dishes-game-wrap{
    position: relative;
    top: 0;
    left: 0%;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    background-size: cover;
    background-position: 50%;
    background-image: url('../assets/section-bg-off.jpg');
    overflow: hidden;
    z-index: 4;
    &.overlayed{
      left: -100%;
      position: fixed;
      .intro-game-dishes{
        flex-wrap: inherit;
      }
    }
    h2 {
      font-weight: bold;
    }
    .intro-game-dishes{
      position: relative;
      top: 0;
      left: 0;
      width: 200%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: row;
      flex-wrap: wrap;
      
    }
    .section--slide{
      position: relative;
      height: 100vh;
      width: 100vw;
      text-align: center;
      display: flex;
      justify-content: center;
      flex-direction: column;
      &.intro--page{
        img{
          margin: 0  auto;
          transform: scale(.7);
          opacity: 0;
          max-width: 300px;
          @media screen and(max-width: 767px){
            width: 80%;
          }
        }
        .title-section{
          margin: 30px auto 20px;
          transform: translateY(50px);
          opacity: 0;
          font-size: 48px;
          color: #000;
          padding: 0 40px;
          @media screen and(max-width: 767px){
            font-size: 24px;
            line-height: 30px;
            padding: 0 20px;
          }
        }
        .subtitle-section{
          margin: 0 auto 0;
          transform: translateY(50px);
          opacity: 0;
          color: #000;
          font-size: 32px;
          padding: 0 40px;
          @media screen and(max-width: 767px){
            font-size: 18px;
            line-height: 24px;
            padding: 0 20px;
          }
        }
      }
      &.intro--earth{
        justify-content: flex-start;
      }
    }
    .intro-chat-wrap{
      position: relative;
      width: 80%;
      margin: 0 auto;
      top: 10%;
      .intro-chat-earth{
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 0 80px;
        .balloon-intro{
          align-self: flex-start;
          padding: 50px 20px;
          background-color: #fff;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          border-bottom-right-radius: 5px;
          text-align: center;
          font-size: 24px;
          opacity: 0;
        }
        .button-intro{
          text-align: right;
          margin: 20px 0 0 auto;
          border: 1px solid #2E70E2;
          background-color: #2E70E2;
          color: #fff;
          padding: 16px 20px;
          font-size: 18px;
          border-radius: 5px;
          cursor: pointer;
          opacity: 0;
        }
      }
      @media screen and(max-width: 860px){
        top: 50%;
        transform: translateY(-50%);
        .intro-chat-earth{
          padding: 0;
        }
      }
      @media screen and(max-width: 767px){
        width: 90%;
        .intro-chat-earth{
          .balloon-intro{
            padding: 20px 10px;
            font-size: 18px;
          }
        }
      }
    }
    .avatar-intro-earth{
      position: absolute;
      bottom: 0;
      transform: translateX(-100%) translateY(50%);
      left: 0;
      opacity: 0;
      width: 150px;
      @media screen and(max-width: 767px){
        width: 100px;
        transform: translateX(-100%) translateY(20px);
      }
    }
  } 
    
</style>